import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { myDatePickerOptions } from 'src/app/services/url.servicios';
import { HistorialService } from 'src/app/services/historial.service';

@Component({
  selector: 'app-form-emm',
  templateUrl: './form-emm.component.html',
  styles: []
})
export class FormEMMComponent implements OnInit {

  myDatePickerOptions = myDatePickerOptions;
  placeholder_1: String = 'Fecha';
  total = 3;
  pagina = 1;
  data = [];
  result = [];
  seleccionado: { Cat_Escalas_Id: number, Fecha: any, Puntaje: number, Observaciones: string } = { Cat_Escalas_Id: 0, Fecha: undefined, Puntaje: 0, Observaciones: '' };
  seleccionado_1: any;

  constructor(
    public _catalogoSrv: CatalogoService,
    public _historialSrv: HistorialService
  ) {
    this.paginador();
  }

  ngOnInit() {
  }

  paginador() {
    this._catalogoSrv.escalas_detalle('EMM', this.pagina, 11)
      .then((data: any[]) => {
        this.data = [];
        this.data.push(...data);
        // this.recargar();
      });

    this._historialSrv.escalas(1, 4, 1, 12)
      .then((data: any[]) => {
        this.result = [];
        this.result.push(...data); console.log(this.result);

        // this.recargar();
      });
  }

  suma() {
    this.seleccionado.Puntaje = 0;
    this.data.forEach(element => {
      this.seleccionado.Puntaje += Number(element.Puntaje);
    });
  }

  seleccionar(item: any) {
    this.data.forEach(element => {
      element.Seleccionado = false;
    });
    item.Seleccionado = !item.Seleccionado;
    this.seleccionado = item;
  }

  seleccionar_1(item: any) {
    // this._catalogoSrv.edad_escolaridad.forEach(element => {
    //   element.Seleccionado = false;
    // });
    // item.Seleccionado = !item.Seleccionado;
    // this.seleccionado_1 = item;
  }

  guardar(forma: NgForm) {
    this.seleccionado.Cat_Escalas_Id = 4;
    this.seleccionado.Fecha = this.seleccionado.Fecha.formatted;

    this._historialSrv.insertar_escala(this.seleccionado)
      .then(() => {
        this.seleccionado = { Cat_Escalas_Id: 0, Fecha: null, Puntaje: 0, Observaciones: '' };
        this.paginador();
      });
  }

  validar(forma: NgForm): boolean {
    return forma.invalid;
  }

  prevPaginado(pagina: number) {
    if (this.pagina - pagina < 1) {
      this.pagina = 1;
    } else {
      this.pagina = this.pagina - pagina;
    }
  }

  nextPaginado(pagina: number) {
    if (this.pagina + pagina > this.total) {
      this.pagina = this.total;
    } else {
      this.pagina = this.pagina + pagina;
    }
  }

}
